<div
  class="flex flex-row items-center text-xs"
  [ngClass]="{
    'text-success-500': isGood(),
    'text-warn-500': isBad(),
    'text-slate-300': isNeutral()
  }"
>
  <mat-icon fontSet="material-symbols" class="icon-sm">
    {{ icon() }}
  </mat-icon>
  <ng-content />
</div>
